module.exports = __webpack_public_path__ + "static/media/bt-fechar.30de2cb1.svg";